<div fxLayoutGap="0.5rem">
	<app-add-contact
		(contactAdded)="editedContact($event)"
		[carrierid]="carrierId"
		[contact]="contact"
		[isEdit]="true"
	>
	</app-add-contact>
	<mat-icon (click)="deleteContact(contact)" style="color: red; cursor: pointer"
		>delete_forever</mat-icon
	>

	<app-move-contact [carrier]="carrier" [contactId]="contact.id"></app-move-contact>
</div>
